import { render } from "./categoryattributelistshared.vue?vue&type=template&id=82b348c6"
import script from "./categoryattributelistshared.vue?vue&type=script&lang=js"
export * from "./categoryattributelistshared.vue?vue&type=script&lang=js"

import exportComponent from "E:\\DeepakKumarJha\\TfsProjects\\EngeeGit\\EngeeAPI\\AdminPanel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__